/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo, useCallback, useRef, useState } from "react";
import { useEmojis } from "@smartsuite/react-ui/lib/components/widgets/EmojiPicker/hooks/useEmojis";
import { EmojiPicker } from "@smartsuite/react-ui/lib/components/widgets/EmojiPicker/EmojiPicker/EmojiPicker";
import { useSuggester } from "../../../../core/suggest/useSuggester";
import { EditorCursorPopup } from "../../../popup";
export const EmojiSuggesterRaw = ({ view, suggesterCallbacksRegistry, matchOffset, }) => {
    const [suggester, setSuggester] = useState(null);
    const searchQuery = suggester === null || suggester === void 0 ? void 0 : suggester.queryText.partial;
    const { emojis, categories } = useEmojis({ searchQuery });
    const handleEnter = useCallback((index) => {
        suggester.command(emojis[index].char);
    }, [suggester, emojis]);
    const handleClick = useCallback((emoji) => {
        suggester.command(emoji.char);
    }, [suggester]);
    const pickerRef = useRef();
    const { visible, activeIndex, setActiveIndex } = useSuggester({
        menuRef: pickerRef,
        suggesterCallbacksRegistry,
        commandsLength: emojis.length,
        commandsRowLength: 8,
        onEnter: handleEnter,
        onParamsChange: useCallback((suggesterParams) => setSuggester(suggesterParams), []),
    });
    if (!visible || !suggester || (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.length) < matchOffset) {
        return null;
    }
    return (React.createElement(EditorCursorPopup, { view: view, from: suggester.range.from, to: suggester.range.to, placement: "bottom-start", flipEnabled: true, preventOverFlowEnabled: false },
        React.createElement("div", { ref: pickerRef, onMouseDown: (e) => e.preventDefault() },
            React.createElement(EmojiPicker, { emojis: emojis, categories: categories, activeIndex: activeIndex, onClick: handleClick, onActiveIndexChange: setActiveIndex }))));
};
export const EmojiSuggester = memo(EmojiSuggesterRaw);
